<template>
    <span>
        <el-button :disabled="order_ids.length == 0" type="primary" size="small" @click="dialogVisible = true">{{buttonName}}</el-button>
        <el-dialog title="接管订单" :visible="dialogVisible" center :before-close="handleCloseDialog">
            <el-form :model="form" ref="form" :rules="rules">
                <el-form-item label="接管人" :label-width="formLabelWidth" prop="user_id" >
                    <UserSelect v-model="form.user_id" @change="UserHandleChange"></UserSelect>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="handleCloseDialog">关闭</el-button>
                <el-button type="primary" @click="handleSubmit" :loading="loading">保存</el-button>
            </div>
        </el-dialog>
    </span>
</template>
<script>
import UserOrdersService from "~/services/UserOrders";
import UserSelect from "~/widgets/UserSelectCorp.vue";
export default {
props:{
    order_ids:{
        type: Array,
        required: true,
        default: []
    },
    buttonName:{
        type: String,
        required: true,
        default: '接管订单'
    },
},
components:{
    UserSelect
},

data() {
    return {
        dialogVisible:false,
        options: [],
        form: {
            user_id:'',
            order_ids: [],
        },
        rules: {
            user_id: [{required: true, message: "请选择接管人", trigger: "change"}],
        },
        formLabelWidth: '100px',
        loading: false,
    };
},
created() {
    this.form.order_ids = this.order_ids;
},
methods:{
    handleSubmit(){
        this.$refs["form"].validate(valid => {
            if (valid) {
                this.loading = true;
                UserOrdersService.takeOver(this.form).then(res => {
                    if (res.code == 0) {
                        this.$message({
                            message:'编辑成功',
                            type:'success'
                        });
                        this.$emit("change", this.form);
                        this.handleCloseDialog();
                    }
                    this.loading = false;
                })
            } else {
                return false;
            }
        });
    },

    handleCloseDialog(){
        this.dialogVisible = false;
    },

    //业务员姓名远程搜索组件赋值
    UserHandleChange(value) {
        this.form.user_id = value;
    },
}
}
</script>




// WEBPACK FOOTER //
// src/views/order/dialog/takeOverForm.vue